import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=adae05d2&"
import script from "./Fieldset.vue?vue&type=script&lang=js&"
export * from "./Fieldset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports